var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3812_5934",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3773 6.82157L15.9036 9.39761C16.2097 9.651 16.4473 9.58765 16.4473 9.1284L16.4473 1.27356C16.4473 0.750964 16.1569 0.814309 15.9036 1.00434L12.3773 3.57511L12.3773 6.82157ZM0.447266 9.10728L0.447266 3.24783C0.452544 1.92285 1.5347 0.85654 2.85439 0.861818L11.3955 0.861818C11.6383 0.861818 11.8336 1.05713 11.8336 1.29468L11.8336 7.15413C11.8283 8.47911 10.7462 9.54542 9.42648 9.54014L0.885405 9.54014C0.642581 9.54014 0.447266 9.34483 0.447266 9.10728Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3812_5934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.228516 10.2168L17.1229 10.2168L17.1229 0.187103L-0.228516 0.187103L-0.228516 10.2168Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventVideoIcon);
export default __webpack_public_path__ + "static/media/event-video-icon.e0e14e2c3e8e3675d2184e7ee3835fab.svg";
export { ForwardRef as ReactComponent };